import moment from 'moment'

import { IReceipt, ReceiptType } from '@/types/receipt'

import { dateToDisplay } from '@/utils/dateFormatter'
import { extractNgText } from './extractNgText'
import { IShop, ShopType } from '@/types/shop'

export const receiptToRow = (
  receipt: IReceipt,
  receiptType: ReceiptType,
): Record<string, string | number> => {
  const row: Record<string, string | number> = {
    id: receipt.id,
    chainStoreName: receipt.chainStore
      ? receipt.chainStore.name
      : receipt.shop?.chainStore
      ? receipt.shop.chainStore?.name || '-'
      : '-',
    storeName: receipt.shop?.name || '-',
    phone: receipt.phone || '-',
    date: moment(receipt.importedAt).valueOf(),
    dateToDisplay: dateToDisplay(receipt.importedAt),
    totalReceipt: receipt.items.length,
  }
  if (receiptType === 'unchecked') {
    row.systemOkedToDisplay = dateToDisplay(receipt.systemOkedAt)
    return row
  }
  if (receiptType === 'linkerChecked') {
    row.okedByLinkerId = receipt.okedByLinkerId || '-'
    row.linkerOkedToDisplay = dateToDisplay(receipt.linkerOkedAt)
    return row
  }
  if (receiptType === 'leaderChecked') {
    row.okedByLinkerId = receipt.okedByLeaderId || '-'
    row.linkerOkedToDisplay = dateToDisplay(receipt.leaderOkedAt)
    return row
  }
  if (receiptType === 'uncheckedSystemNg' || receiptType === 'systemNg') {
    row.systemNgedToDisplay = dateToDisplay(receipt.systemNgedAt)
    row.ngText = extractNgText(receipt)
    return row
  }
  if (receiptType === 'linkerNg') {
    row.ngedByLinkerId = receipt.ngedByLinkerId || '-'
    row.linkerNgedToDisplay = dateToDisplay(receipt.linkerNgedAt)
    row.ngText = extractNgText(receipt)
    return row
  }
  if (receiptType === 'leaderNg') {
    row.linkerId = receipt.okedByLinkerId || receipt.ngedByLinkerId || '-'
    row.linkerOkedToDisplay = dateToDisplay(receipt.linkerOkedAt)
    row.linkerNgedToDisplay = dateToDisplay(receipt.linkerNgedAt)
    row.ngedByLeaderId = receipt.ngedByLeaderId || '-'
    row.leaderNgedToDisplay = dateToDisplay(receipt.leaderNgedAt)
    row.ngText = extractNgText(receipt)
    return row
  }
  return row
}

export const receiptTypeToDisplayName = (receiptType: ReceiptType): string => {
  switch (receiptType) {
    case 'unchecked':
      return '未チェック'
    case 'linkerChecked':
      return '処理結果/リンカーOK'
    case 'leaderChecked':
      return '処理結果/リーダーOK'
    case 'uncheckedSystemNg':
      return '処理残/システムNG'
    case 'systemNg':
      return '処理結果/システムNG'
    case 'systemOk':
      return '処理結果/システムOK'
    case 'linkerNg':
      return '処理残/リンカーNG'
    case 'leaderNg':
      return '処理結果/リーダーNG'
    case 'shopUnchecked':
      return '店舗登録申請承認'
    case 'newItem':
      return '新規紐付商品'
    case 'reItem':
      return '紐付変更商品'
  }
}

export const shopToRow = (
  shop: IShop,
  shopType: ShopType,
): Record<string, string | number> => {
  const row: Record<string, string | number> = {
    id: shop.id,
    phone: shop.tel || '-',
    channelName: shop.chainStore.channel.name || '-',
    chainStoreName: shop.chainStore.name || '-',
    shopName: shop.name,
    appliedByLeaderId: shop.appliedByLeaderId || '-',
    leaderAppliedToDisplay: dateToDisplay(shop.leaderAppliedAt),
  }
  if (shopType === 'unchecked') {
    return row
  }
  if (shopType === 'checked') {
    return row
  }
  return row
}

export const getReceiptType = (receipt: IReceipt): ReceiptType => {
  if (receipt.leaderOkedAt) {
    if (receipt.leaderNgedAt) {
      if (receipt.leaderOkedAt > receipt.leaderNgedAt) {
        return 'leaderChecked'
      } else {
        return 'leaderNg'
      }
    } else {
      return 'leaderChecked'
    }
  }
  if (receipt.leaderNgedAt) {
    return 'leaderNg'
  }
  if (receipt.linkerOkedAt) {
    if (receipt.linkerNgedAt) {
      if (receipt.linkerOkedAt > receipt.linkerNgedAt) {
        return 'linkerChecked'
      } else {
        return 'linkerNg'
      }
    } else {
      return 'linkerChecked'
    }
  }
  if (receipt.linkerNgedAt) {
    return 'linkerNg'
  }
  if (receipt.systemOkedAt) {
    if (receipt.isAutoCompleted) {
      return 'systemOk'
    } else {
      return 'unchecked'
    }
  }
  if (receipt.systemNgedAt) {
    return 'systemNg'
  }
  console.error('unexpected receipt type', receipt)
  return 'unchecked'
}
